// https://flowbite.com/docs/components/skeleton/

import React, { useEffect } from "react";

// Import utilities
import { tailwindConfig } from "../utils/Utils";

function Skeleton(props) {
  let type = props.type;
  let color = props.color ? props.color : "gray";
  let fill = props.fill ? props.fill : "primary";
  if (fill == "purple") {
    fill = "primary";
  }
  let forButton = props.forButton ? props.forButton : false;
  let forIcon = props.forIcon ? true : false;
  if (type === "newSpinner") {
    return (
      <div role="status">
        <svg
          class="inline mr-2 w-8 h-8 text-slate-200 animate-spin dark:text-slate-600 fill-primary-500"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
        <span class="sr-only">Loading...</span>
      </div>
    );
  }

  if ((type = "spinner")) {
    return (
      <div
        class={` ${
          forButton !== true
            ? forIcon === true
              ? "mr-0 inline-flex p-0 "
              : "p-10 text-center "
            : null
        }`}
      >
        <div role="status">
          <svg
            class={`inline   animate-spin  ${
              forButton
                ? "text-" + color + "-200"
                : "text-" + color + "-200 dark:text-" + color + "-300"
            } 
            ${forIcon ? "mr-0" : forButton ? "mr-2" : "mr-2"}
            
            ${forButton ? "w-4 h-4 " : forIcon ? "w-4 h-4 " : "w-8 h-8"}  
             
            
            ${forButton ? "fill-" + fill + "-500" : "fill-" + fill + "-500"} `}
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    );
  }
  if (type == "text") {
    return (
      <div role="status" class="max-w-sm animate-pulse">
        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-48 mb-4"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 max-w-[360px] mb-2.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 mb-2.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 max-w-[330px] mb-2.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 max-w-[300px] mb-2.5"></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-300 max-w-[360px]"></div>
        <span class="sr-only">Loading...</span>
      </div>
    );
  }
  if (type == "widget") {
    return (
      <div
        role="status"
        class="p-4 max-w-sm rounded border border-gray-200 shadow animate-pulse md:p-6 dark:border-gray-700"
      >
        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-32 mb-2.5"></div>
        <div class="mb-10 w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-300"></div>
        <div class="flex items-baseline mt-4 space-x-6">
          <div class="w-full h-72 bg-gray-200 rounded-t-lg dark:bg-gray-300"></div>
          <div class="w-full h-56 bg-gray-200 rounded-t-lg dark:bg-gray-300"></div>
          <div class="w-full h-72 bg-gray-200 rounded-t-lg dark:bg-gray-300"></div>
          <div class="w-full h-64 bg-gray-200 rounded-t-lg dark:bg-gray-300"></div>
          <div class="w-full h-80 bg-gray-200 rounded-t-lg dark:bg-gray-300"></div>
          <div class="w-full h-72 bg-gray-200 rounded-t-lg dark:bg-gray-300"></div>
          <div class="w-full h-80 bg-gray-200 rounded-t-lg dark:bg-gray-300"></div>
        </div>
        <span class="sr-only">Loading...</span>
      </div>
    );
  }
  if (type === "square") {
    return (
      <div
        role="status"
        class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center"
      >
        <div class="flex justify-center items-center w-1/2 h-48 bg-gray-200 rounded sm:w-96 dark:bg-gray-300">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-12 h-12 text-slate-800"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
            />
          </svg>
          {/* <svg
            class="w-12 h-12 text-slate-200"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 640 512"
          >
            <path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
          </svg> */}
        </div>
        {/* <div class="w-full">
          <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
          <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[480px] mb-2.5"></div>
          <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
          <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[440px] mb-2.5"></div>
          <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[460px] mb-2.5"></div>
          <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
        </div> */}
        <span class="sr-only">Loading...</span>
      </div>
    );
  }
}

export default Skeleton;
